import script from "./danh-sach-tai.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-tai.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-tai.vue?vue&type=style&index=0&id=742be0dd&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742be0dd"]])

export default __exports__